module.exports = __webpack_public_path__ + "static/media/marketing-design.4979af5e.svg";